var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Link",
    clipPath: "url(#clip0_1940_2246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 20C6.5 17.15 8.81667 14.8333 11.6667 14.8333H18.3333V11.6667H11.6667C7.06667 11.6667 3.33334 15.4 3.33334 20C3.33334 24.6 7.06667 28.3333 11.6667 28.3333H18.3333V25.1667H11.6667C8.81667 25.1667 6.5 22.85 6.5 20ZM13.3333 21.6667H26.6667V18.3333H13.3333V21.6667ZM28.3333 11.6667H21.6667V14.8333H28.3333C31.1833 14.8333 33.5 17.15 33.5 20C33.5 22.85 31.1833 25.1667 28.3333 25.1667H21.6667V28.3333H28.3333C32.9333 28.3333 36.6667 24.6 36.6667 20C36.6667 15.4 32.9333 11.6667 28.3333 11.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1940_2246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteWebsite);
export default __webpack_public_path__ + "static/media/White-Website.151b1f6e82cb33c71de1f33513db778a.svg";
export { ForwardRef as ReactComponent };